import React, { Component } from 'react';
import './Fields.css';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import withAuthorization  from './withAuthorization';
import AuthService from '../services/auth';
import Api from '../services/api';
import { productName } from '../helpers/functions';
import moment from 'moment'
import redCross from '../static/vectors/close-red.svg';
import greenCheck from '../static/vectors/check-circle-green.svg';
import './SettingsPayments.css';

class SettingsPayments extends Component {

  constructor(props) {
    super(props);

    this.state = {
      magnets: [],
      upgrades: []
    };
  }

  componentDidMount(){
    (new Api()).get('/payments/list', {}, AuthService.getAuthCookie())
      .then(response => {
        this.setState(response);
      })
  }

  render() {
    const { upgrades, magnets } = this.state;
    return (
      <div className="col col-12 col-md-8">
        <div className="title">
          Membership subscriptions
        </div>
        <div className="payments-list">
          {upgrades.map(payment => {
            let statusIcon = (['source.failed', 'source.canceled'].includes(payment.chargeId) || payment.chargeId.length === 0)?redCross : greenCheck;
            return(
              <div key={payment.id} className="row single-payment">
                <div className="col col-12">
                  <div className="name">
                    {`${productName(payment.product)} ${(payment.dateName)?'Date with ' + payment.dateName : ''}`}
                    <div className={'icon'}>
                      <img src={statusIcon} alt={'status'} />
                    </div>
                  </div>
                </div>
                <div className="col col-6 data">
                  Date: {moment(payment.created_at).format('MMMM DD, YYYY')}
                </div>
                <div className="col col-6 data">
                  Method: {payment.method}
                </div>
                {/*<div className="col col-6 data">
                  Order: {moment(payment.created_at).format('MMMM DD, YYYY')}
                </div>
                <div className="col col-6 data">
                  Visible as: {moment(payment.created_at).format('MMMM DD, YYYY')}
                </div>*/}
              </div>
            );
          })}
        </div>
        <div className="title">
          Magnets
        </div>
        <div className="payments-list">
          {magnets.map(payment => {
            let statusIcon = (['source.failed', 'source.canceled'].includes(payment.chargeId) || payment.chargeId.length === 0)?redCross : greenCheck;
            return(
              <div key={payment.id} className="row single-payment">
                <div className="col col-12">
                  <div className="name">
                    {productName(payment.product)}
                    <div className={'icon'}>
                      <img src={statusIcon} alt={'status'} />
                    </div>
                  </div>
                </div>
                <div className="col col-6 data">
                  Date: {moment(payment.created_at).format('MMMM DD, YYYY')}
                </div>
                <div className="col col-6 data">
                  Method: {payment.method}
                </div>
                {/*<div className="col col-6 data">
                  Order: {moment(payment.created_at).format('MMMM DD, YYYY')}
                </div>
                <div className="col col-6 data">
                  Visible as: {moment(payment.created_at).format('MMMM DD, YYYY')}
                </div>*/}
              </div>
            );
          })}
        </div>
      </div>
    )
  }
}


const mapStateToProps = (state, props) => {
  return({
    ...props,
    ucdUser: state.sessionState.ucdUser,
    authUser: state.sessionState.authUser,
  });};

const authCondition = (authUser) => !!authUser;

export default compose(withAuthorization(authCondition), connect(mapStateToProps))(SettingsPayments);


// WEBPACK FOOTER //
// ./src/components/SettingsPayments.js